"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetI18nInstance = exports.t = exports.createI18nInstance = exports.setI18nInstance = void 0;
var tslib_1 = require("tslib");
var i18next_1 = tslib_1.__importDefault(require("i18next"));
var i18nInstance = null;
var setI18nInstance = function (_i18nInstance) {
    i18nInstance = _i18nInstance;
};
exports.setI18nInstance = setI18nInstance;
var createI18nInstance = function (locale) {
    return new Promise(function (resolve) {
        var instance = i18next_1.default.createInstance();
        instance
            .use({
            type: 'backend',
            read: function (language, namespace, callback) {
                var _a;
                // We configure how i18next should fetch a translation resource when it
                // needs it: We use Webpack's dynamic imports to fetch resources without
                // increasing our bundle size.
                //
                // See https://webpack.js.org/guides/code-splitting/#dynamic-imports for
                // more information.
                return (_a = "../../locales/messages_".concat(language, ".json"), Promise.resolve().then(function () { return tslib_1.__importStar(require(_a)); })).then(function (translation) { return callback(null, translation); })
                    .catch(function (error) { return callback(error); });
            },
        })
            .init({
            // Initial language
            lng: locale,
            // Fallback language
            fallbackLng: 'en',
            // Don't use a key separator (no support for nested translation objects)
            keySeparator: false,
        }, function (err) {
            if (err) {
                console.log(err);
                instance.changeLanguage('en');
                resolve(instance);
            }
            else {
                resolve(instance);
            }
        });
    });
};
exports.createI18nInstance = createI18nInstance;
var t = function (keys, options) {
    if (!i18nInstance) {
        return keys;
    }
    return i18nInstance.t(keys, options);
};
exports.t = t;
var resetI18nInstance = function () {
    i18nInstance = null;
};
exports.resetI18nInstance = resetI18nInstance;
//# sourceMappingURL=createI18nInstance.js.map